import React, { useState,useEffect } from "react";
import Styles from "./style.js";
import Icon from "./icon.js";
import { useRef } from "react";
import Box from '@mui/material/Box';
import Slider from "@mui/material/Slider";
//import Theme from '../../resources/themes/light.js'

export { default as Button } from "./Button";

export const ShimmerBox = ({
  width = "100%",
  height = "40px",
  borderRadius = "4px",
  margin,
}) => (
  <div className="shimmer" style={{ width, height, borderRadius, margin }} />
);

export const CustomText = function (props) {
  // Function for text styling
  function textStyle(props) {
    var style;
    if (props.textColor) {
      style = Styles[props.textColor];
    }
    if (props.fontSize) {
      style = { ...style, ...Styles[props.fontSize] };
    }
    if (props.fontWeight) {
      style = { ...style, ...Styles[props.fontWeight] };
    }
    if (props.textAlign) {
      style = { ...style, ...Styles[props.textAlign] };
    }
    if (props.width) {
      style = { ...style, ...Styles[props.width] };
    }
    if (props.height) {
      style = { ...style, ...Styles[props.height] };
    }
    if (props.lineHeight) {
      style = { ...style, ...Styles[props.lineHeight] };
    }
    if (props.noOfLine) {
      style = { ...style, ...Styles[props.noOfLine] };
    }
    if (props.ellipsis) {
      style = { ...style, ...Styles["ellipsisText"] };
    }
    return style;
  }

  // Define the class name based on props
  let className = props.className ? props.className : "";

  if (props.h1) {
    return <h1 style={textStyle(props)}>{props.text}</h1>;
  } else if (props.h2) {
    return <h2 style={textStyle(props)}>{props.text}</h2>;
  } else if (props.h3) {
    return <h3 style={textStyle(props)}>{props.text}</h3>;
  } else if (props.h4) {
    return <h4 style={textStyle(props)}>{props.text}</h4>;
  } else if (props.h5) {
    return (
      <h5 className={className} style={textStyle(props)}>
        {props.text}
      </h5>
    );
  }
  if (props.h6) {
    return <h6 style={textStyle(props)}>{props.text}</h6>;
  } else if (props.label) {
    return <label style={textStyle(props)}>{props.text}</label>;
  } else if (props.p) {
    return (
      <p className={className} style={textStyle(props)}>
        {props.text}
      </p>
    );
  }
};

export const H1 = function (props) {
  return (
    <h1
      style={
        props.type === "primary"
          ? Styles.h1Primary
          : props.type === "disabled"
          ? Styles.h1Disabled
          : props.type === "green"
          ? Styles.h1Green
          : Styles.h1Default
      }
    >
      {props.text}
    </h1>
  );
};

export const H2 = function (props) {
  return (
    <h2
      style={
        props.type === "primary"
          ? Styles.h2Primary
          : props.type === "disabled"
          ? Styles.h2Disabled
          : Styles.h2Default
      }
    >
      {props.text}
    </h2>
  );
};

export const H3 = function (props) {
  return (
    <h3
      style={
        props.type === "primary"
          ? Styles.h3Primary
          : props.type === "disabled"
          ? Styles.h3Disabled
          : Styles.h3Default
      }
    >
      {props.text}
    </h3>
  );
};

export const Medium = function (props) {
  return (
    <p
      style={
        props.type === "primary"
          ? Styles.mediumPrimary
          : props.type === "disabled"
          ? Styles.mediumDisabled
          : props.type === "light"
          ? Styles.mediumLight
          : Styles.mediumDefault
      }
    >
      {props.text}
    </p>
  );
};

export const Image = function (props) {
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleImageError = () => {
    setImageLoaded(true);
  };
  return (
    <img
      className={props.className}
      onClick={props.onClick}
      style={props.style}
      alt={props.alt}
      src={imageLoaded ? props.fallBack : props.source}
      width={props.width}
      height={props.height}
      onError={handleImageError}
    />
  );
};

// export const Video = function (props) {
//   return (
//     <div>
//       <Video
//         source={props.source}
//         type="video/mp4"
//         className={props.className}
//         controls
//         width={props.width}
//         height={props.height}
//       />
//     </div>
//   );
// };

export const Video = function (props) {
  const handleContextMenu = (e) => {
    e.preventDefault(); // Prevent default right-click behavior
  };
  return (
    <div>
      <video
        controlsList="nodownload"
        className={props.className}
        onClick={props.onClick}
        style={props.style}
        controls
        muted={props.muted}
        autoPlay={props.autoPlay}
        loop={props.loop}
        preload={props.preload}
        width={props.width}
        height={props.height}
        onContextMenu={handleContextMenu}
      >
        <source src={props.source} type={props.type} />
      </video>
    </div>
  );
};

export const CustomTextInput = function (props) {
  const [passwordType, setPasswordType] = useState(true);
  const inputRef = useRef(null);

  const togglePassword = () => {
    setPasswordType(!passwordType);
  };

  const handleClear = () => {
    if (props.onChange) {
      // Create a synthetic event to pass to the onChange handler
      const event = {
        target: {
          value: '',
          name: props.name
        }
      };
      props.onChange(event);
    }
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  // Determine border color based on error prop
  const getBorderColor = () => {
    if (props.disabled) return "none";
    if (props.error) return "1px solid #f04248"; // Red border for errors
    if (props.borderColor === "blue" && !props.borderWidth) return "2px solid var(--blue-blue-500)";
    if (props.borderWidth && props.borderColor === "blue") return `${props.borderWidth} solid var(--blue-blue-500)`;
    return "1px solid #ccc"; // Default border
  };

  return (
    <div
      className={`customTextBoxMainContainer ${props.newWidth || ""}`}
      style={{
        width: props.width || "100%",
        borderRadius: props.borderRadius || "6px",
        padding: props.padding ? props.padding : "12px",
        position: "relative",
        display: "flex",
        alignItems: "center",
        maxWidth:"-webkit-fill-available",
        border: getBorderColor(),
        backgroundColor: props.disabled ? "#f0f0f0" : "white",
      }}
    >
      <input
        ref={inputRef}
        {...props}
        className={props.className}
        style={{
          flex: 1,
          border: "none",
          outline: "none",
          backgroundColor: "transparent",
          color: props.disabled ? "#a0a0a0" : "black",
          cursor: props.disabled ? "not-allowed" : "text",
          padding: 0,
          margin: 0,
        }}
        maxLength={props.maxLength}
        placeholder={props.placeholder}
        onCut={props.onCut}
        onChange={props.onChange}
        onSelect={props.onSelect}
        onBlur={props.onBlur}
        autoFocus={props.autoFocus}
        disabled={props.disabled}
        defaultValue={props.defaultValue}
        onKeyDown={props.onKeyDown}
        value={props.value}
        onWheel={(e) => {
          if (props.type === "number") {
            e.target.blur();
            e.preventDefault();
          } else {
            props.onWheel?.(e);
          }
        }}
        type={passwordType ? props.type : "text"}
      />

      {/* Clear Button - Only show when there's a value and not disabled */}
      {props.showClear && props.value && !props.disabled && (
        <button
          type="button"
          onClick={handleClear}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#666',
          }}
          aria-label="Clear input"
        >
          <Icon iconName="crossIcon" width={16} height={16} />
        </button>
      )}

      {/* Password Toggle Button */}
      {props.type === "password" && (
        <button 
          type="button"
          className="toggle-password-btn" 
          onClick={togglePassword}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '0 4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {passwordType ? (
            <Icon iconName="ClosedEye" width={17} height={14.806} />
          ) : (
            <Icon iconName="OpenEye" width={17} height={14.806} />
          )}
        </button>
      )}

      {/* Right-side Button */}
      {props.hideVerifyBtn === 0 && props.rightBtn && (
        <div className={props.verifyClass} style={{ marginLeft: '8px' }}>
          <LinkCta
            text={props.text}
            onClick={props.onClickVerify}
            textColor="text_color_register"
          />
        </div>
      )}
    </div>
  );
};

export const CustomTextArea = function (props) {
  return (
    <div
      className={props.className}
      style={
        props.invert
          ? Styles.invert_custom_text_area
          : Styles.customtextarea_box_main_container
      }
    >
      <textarea
        className={props.className}
        style={
          props.invert
            ? Styles.custom_textarea_box_main_wrapper
            : Styles.custom_textarea_box_main_wrapper_box
        }
        rows={props.rows}
        cols={props.cols}
        required={props.required}
        wrap={props.wrap}
        disabled={props.disabled}
        placeholder={props.placeholder}
        maxLength={props.maxLength}
        name={props.name}
        resize={props.resize}
        value={props.value}
        onChange={props.onChange}
        readOnly={props.readOnly}
      />
    </div>
  );
};

// export const PrimaryCta = function (props) {
//   var style = Styles.primaryCtaContainer;
//   var textColor = "text_color_light";
//   if (props.fullWidth) {
//     style = Styles.fullWidthPrimaryCtaContainer;
//   }
//   if (props.fullWidth100) {
//     style = Styles.fullWidthPrimaryCtaContainer100;
//   }

//   if (props.disabled) {
//     style = { ...style, ...Styles.primaryCtaDisabledContainer };
//   }
//   if (props.secondary) {
//     style = { ...style, ...Styles.primaryCtaSecondaryContainer };
//   }
//   if (props.invert) {
//     textColor = props.textColor ? props.textColor : "text_color_primary";
//     style = { ...style, ...Styles.primaryCtaInvertContainer };
//   }
//   if (props.third) {
//     style = {
//       ...style,
//       ...Styles.primaryCtaThirdContainer,
//     };
//   }
//   if (props.borderCta) {
//     style = {
//       ...style,
//       ...Styles.primaryCtaBorderContainer,
//     };
//   }

//   if (props.fourth) {
//     textColor = "text_color_black";
//     style = { ...style, ...Styles.primaryCtaFourthContainer };
//   }
//   if (props.fifth) {
//     textColor = "text_color_light";
//     style = { ...style, ...Styles.primaryCtaFifthContainer };
//   }
//   if (props.sixth) {
//     textColor = "text_color_light";
//     style = {
//       ...style,
//       ...Styles.primaryCtaSixthContainer,
//     };
//   }
//   if (props.white) {
//     style = {
//       ...style,
//       ...Styles.primaryCtaWhiteContainer,
//     };
//   }

//   return (
//     <button
//       className={`primary-cta ${props.className}`}
//       style={style}
//       onClick={props.onClick}
//       disabled={props.disabled}
//     >
//       {!props.isLoading ? (
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "center",
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               // gap: "6px",
//               // justifyContent: "center",
//               // alignContent: "center",
//             }}
//           >
//             {props.iconName && (
//               <div style={{ marginTop: "4px", marginRight: "6px" }}>
//                 <Icon iconName={props.iconName} height={12} width={12} />
//               </div>
//             )}

//             <CustomText
//               p
//               className="button-text"
//               text={props.text}
//               //fontSize={props.fontSize}
//               // fontSize={"font_size_large"}
//               textColor={props.textColor ? props.textColor : textColor}
//               //fontWeight={"Poppins_regular"}
//             />
//           </div>
//         </div>
//       ) : (
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "center",
//             paddingRight: 16,
//             paddingLeft: 16,
//             paddingTop: 2,
//             paddingBottom: 2,
//             color: "white",
//             fontSize: 15,
//           }}
//         >
//           <i className="fa fa-circle-o-notch fa-spin"></i>
//         </div>
//       )}
//     </button>
//   );
// };

export const PrimaryCta = function (props) {
  const [isHovered, setIsHovered] = useState(false);

  let style = Styles.primaryCtaContainer;
  let textColor = "text_color_light";

  if (props.yellowButton) style = Styles.yellowButtonStyle;
  if (props.fullWidth) style = Styles.fullWidthPrimaryCtaContainer;
  if (props.no_width) {
    style = Styles.no_widthCtaContainer;
    textColor = "black";
  }
  if (props.fullWidth100) style = Styles.fullWidthPrimaryCtaContainer100;
  if (props.disabled)
    style = { ...style, ...Styles.primaryCtaDisabledContainer };
  if (props.secondary)
    style = { ...style, ...Styles.primaryCtaSecondaryContainer };
  if (props.invert) {
    textColor = props.textColor || "white";
    style = { ...style, ...Styles.primaryCtaInvertContainer };
  }
  if (props.invertSmall) {
    textColor = props.textColor || "white";
    style = { ...style, ...Styles.primaryCtaInvertSmallContainer };
  }
  if (props.invertVerySmall) {
    textColor = props.textColor || "white";
    style = { ...style, ...Styles.primaryCtaInvertVerySmallContainer };
  }
  if (props.third) style = { ...style, ...Styles.primaryCtaThirdContainer };
  if (props.borderCta)
    style = { ...style, ...Styles.primaryCtaBorderContainer };
  if (props.fourth) {
    textColor = "text_color_black";
    style = { ...style, ...Styles.primaryCtaFourthContainer };
  }
  if (props.fifth) {
    textColor = "text_color_light";
    style = { ...style, ...Styles.primaryCtaFifthContainer };
  }
  if (props.sixth) {
    textColor = "text_color_light";
    style = { ...style, ...Styles.primaryCtaSixthContainer };
  }
  if (props.white) style = { ...style, ...Styles.primaryCtaWhiteContainer };

  // Apply hover styles
  let hoverStyle = {};
  if (props.fullWidth) hoverStyle = Styles.fullWidthPrimaryCtaContainerHover;
  if (props.fullWidth100)
    hoverStyle = Styles.fullWidthPrimaryCtaContainer100Hover;
  if (props.invert) hoverStyle = Styles.primaryCtaInvertContainerHover;
  if (props.invertSmall)
    hoverStyle = Styles.primaryCtaInvertSmallContainerHover;
  if (props.invertVerySmall)
    hoverStyle = Styles.primaryCtaInvertVerySmallContainerHover;
  if (props.third) hoverStyle = Styles.primaryCtaThirdContainerHover;
  if (props.fifth) hoverStyle = Styles.primaryCtaFifthContainerHover;
  if (props.yellowButton) hoverStyle = Styles.yellowButtonStyleHover;

  const finalStyle = {
    ...style,
    ...(isHovered ? hoverStyle : {}),
    fontWeight: isHovered ? 600 : 500,
    height: props.height || style.height,
    width: props.width || style.width,
    padding: props.padding !== undefined ? props.padding : style.padding || "",
  };

  return (
    <button
      className={`primary-cta ${props.className}`}
      style={finalStyle}
      onClick={() => {
        if (props.onClick) props.onClick();
      }}
      disabled={props.disabled}
      onMouseEnter={() => {
        if (!props.disabled) setIsHovered(true);
      }}
      onMouseLeave={() => {
        if (!props.disabled) setIsHovered(false);
      }}
    >
      {!props.isLoading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {props.twoIcons ? (
            <>
              {props.leftIconName && (
                <div style={{ display: "flex", marginRight: "6px" }}>
                  <Icon iconName={props.leftIconName} height={12} width={12} />
                </div>
              )}
              <span
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "block",
                  maxWidth: props.textMaxWidth,
                }}
              >
                <CustomText
                  p
                  text={props.text}
                  fontSize={props.fontSize || 13}
                  textColor={props.textColor || textColor}
                />
              </span>
              {props.rightIconName && (
                <div style={{ marginLeft: "6px", display: "flex" }}>
                  <Icon iconName={props.rightIconName} height={12} width={12} />
                </div>
              )}
            </>
          ) : (
            <div style={{ display: "flex", alignItems: "center" }}>
              {props.iconPosition === "left" && props.iconName && (
                <div style={{ display: "flex", marginRight: "6px" }}>
                  <Icon iconName={props.iconName} height={12} width={12} />
                </div>
              )}
              <span
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "block",
                  maxWidth: props.textMaxWidth,
                }}
              >
                <CustomText
                  p
                  text={props.text}
                  fontSize={props.fontSize || 13}
                  textColor={props.textColor ? props.textColor : textColor}
                />
              </span>
              {props.iconPosition === "right" && props.iconName && (
                <div style={{ marginLeft: "6px", display: "flex" }}>
                  <Icon iconName={props.iconName} height={12} width={12} />
                </div>
              )}
            </div>
          )}
        </div>
      ) : (
        <div
          className={
            props.invert || props.invertSmall
              ? "loader-back-color-blue"
              : "loader-back-color-white"
          }
          style={{
            display: "flex",
            justifyContent: "center",
            paddingRight: 16,
            minWidth: 30,
            paddingLeft: 16,
            paddingTop: 2,
            paddingBottom: 2,
            fontSize: 13,
          }}
        >
          <i className="fa fa-circle-o-notch fa-spin"></i>
        </div>
      )}
    </button>
  );
};

export const PrimaryCtaInvert = (props) => {
  const [isHovered, setIsHovered] = useState(false);
  const { status, isLoading } = props;

  const isRejected = status === "REJECTED";
  const isAccepted = status === "ACCEPTED";

  const borderColor = props.borderColor ? props.borderColor : isRejected
    ? "var(--general-error)"
    : isAccepted
      ? "#16A34A"
      : "#1977F2";

  const baseStyle = {
    backgroundColor: "#ffffff",
    color: borderColor,
    border: `1px solid ${borderColor}`,
    padding: "8px",
    fontWeight: 500,
    fontSize: "14px",
    maxHeight: "32px",
    borderRadius: "4px",
    cursor: props.disabled ? "not-allowed" : "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
  };

  const hoverStyle = {
    backgroundColor: "#ffffff",
    color: props.borderColor ? props.borderColor : "#176CDC",
    boxShadow: props.borderColor ? `inset 0 0 0 0.5px ${props.borderColor}`: "inset 0 0 0 0.5px #176CDC",
    fontWeight: 600,
  };

  const disabledStyle = {
    backgroundColor: "white",
    color: "var(--gray-gray-200)",
    border: "1px solid var(--gray-gray-200)",
    cursor: "not-allowed",
  };

  const noBorder = {
    backgroundColor: "#ffffff",
    color: "#1977F2",
    border: "none",
    outline: "none",
    padding: "8px",
    fontWeight: 600,
    fontSize: "16px",
    maxHeight: "34px",
    borderRadius: "4px",
    cursor: props.disabled ? "not-allowed" : "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "4px",
  };

  const statusStyle = isRejected
    ? {
      color: "var(--general-error)",
      border: "1px solid  var(--general-error)",
      boxShadow: "inset 0 0 0 0.5px var(--general-error)",
      cursor: "not-allowed",
    }
    : isAccepted
      ? {
        color: "#16A34A",
        border: "1px solid #16A34A",
        boxShadow: "inset 0 0 0 0.5px #16A34A",
        cursor: "not-allowed",
      }
      : {};

  const finalStyle = {
    ...baseStyle,
    ...(props.noBorder ? noBorder : {}),
    ...(props.disabled ? disabledStyle : isHovered ? hoverStyle : {}),
    ...(status ? statusStyle : {}),
    ...props.style,
  };

  return (
    <button
      style={finalStyle}
      className={props.className}
      onClick={() => {
        if (!props.disabled && !status && props.onClick) props.onClick();
      }}
      disabled={props.disabled || isRejected || isAccepted || isLoading}
      onMouseEnter={() => {
        if (!props.disabled && !status) setIsHovered(true);
      }}
      onMouseLeave={() => {
        if (!props.disabled && !status) setIsHovered(false);
      }}
    >
      {isLoading ? (
        <span
          className="fa fa-circle-o-notch fa-spin"
          style={{
            fontSize: 18,
            color: borderColor,
            margin: "0 8px",
          }}
        />
      ) : (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: props.noBorder ? "4px" : "6px",
            padding: props.padding,
          }}
        >
          {props.iconName && props.iconPosition === "left" && (
            <Icon iconName={props.iconName} height={12} width={12} />
          )}
          <span
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "block",
              maxWidth: props.textMaxWidth,
            }}
          >
            {props.text}
          </span>
          {props.iconName && props.iconPosition === "right" && (
            <Icon iconName={props.iconName} height={12} width={12} />
          )}
        </div>
      )}
    </button>
  );
};

export const LinkCta = function (props) {
  //const[is_active, set_is_active] = useState(props.isActive)

  return (
    <button
      style={Styles.linkCtaContainer}
      className={props.className}
      onClick={props.onClick}
    >
      <div>
        <CustomText
          h2
          fontSize={"font_size_small"}
          text={props.text}
          textColor={props.textColor}
          fontWeight={"Poppins_regular"}
        />
      </div>
    </button>
  );
};

export const CustomButton = (props) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const buttonStyle = {
    borderRadius: props.borderRadius || 9,
    maxWidth: 369,
    width: props.width || "100%",
    textAlign: "center",
    paddingRight: props.padding ? props.padding.right : 48,
    paddingLeft: props.padding ? props.padding.left : 48,
    paddingTop: props.padding ? props.padding.top : 15,
    paddingBottom: props.padding ? props.padding.bottom : 15,
    outline: "none",
    border: props.border || 0,
    borderColor: props.borderColor || "none",
    userSelect: "none",
    cursor: "pointer",
     background: props.disabled
    ? "#E0E0E0" // grey200
    : (isHovered
        ? props.hoverColor || "none"
        : props.background || "var(--gradient, linear-gradient(90deg, #A271FE 0%, #F75774 100%)"),
    boxShadow: props.boxShadow || "0px 4px 61px 0px rgba(77, 71, 195, 0.40)",
    height: props.height || "auto",
    ...(isHovered && {
      background: props.hoverColor || "none",
    }),
  };

  return (
    <button
      style={buttonStyle}
      onClick={props.onClick}
      disabled={props.disabled}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {!props.isLoading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              textWrap: "nowrap",
            }}
          >
            {props.iconName && (
              <div style={{ marginTop: "4px", marginRight: "6px" }}>
                <Icon iconName={props.iconName} height={12} width={12} />
              </div>
            )}

            <CustomText
              h3
              text={props.text}
              fontSize={props.fontSize}
              // fontSize={"font_size_large"}
              textColor={props.textColor}
              fontWeight={"Poppins_regular"}
            />
          </div>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            paddingRight: 16,
            paddingLeft: 16,
            paddingTop: 2,
            paddingBottom: 2,
            color: "white",
            fontSize: 15,
          }}
        >
          <i className="fa fa-circle-o-notch fa-spin"></i>
        </div>
      )}
    </button>
  );
};

export const FilterBtn = function (props) {
  // const [isClicked, setIsClicked] = useState(false);

  // const handleClick = () => {
  //   setIsClicked(true);
  // };

  return (
    <div
      // style={{ backgroundColor: isClicked ? "red" : "blue", color:  "white" }}
      className="filterBtn"
      // onClick={handleClick}

      width={props.width}
      height={props.height}
      backgroundColor={props.backgroundColor}
    >
      <div>
        <CustomText
          p
          fontSize={"font_size_medium"}
          text={props.text}
          textColor={props.textColor}
          // fontWeight={"rubik_regular"}
        />
      </div>
    </div>
  );
};

// export const BackButton = function (props) {
//   return (
//     <button
//       className="filterBtn"
//       onClick={props.onClick}
//       width={props.width}
//       height={props.height}
//       backgroundColor={props.backgroundColor}
//     >
//       <div>
//         <CustomText
//           p
//           fontSize={"font_size_medium"}
//           text={props.text}
//           textColor={props.textColor}
//         />
//       </div>
//     </button>
//   );
// };

export const CampaignList = function (props) {
  return (
    <div className="Campaign-list" key={props.key} onClick={props.onClick}>
      <div className="Campaign-list-data-profile">
        <div>
          <Image source={props.source} className="campaign-list-profile" />
        </div>
        <div className="campaign-list-data m-r-16">
          <CustomText
            p
            fontSize={"font_size_medium"}
            text={props.title}
            textColor={"text_color_primary"}
            noOfLine={"twoLines"}
          />
        </div>
      </div>
      {/* <div className="Campaign-list-data">
        <CustomText
          p
          fontSize={"font_size_medium"}
          text={"Type"}
          textColor={"text_light_weight_color"}
        />
        <CustomText
          p
          fontSize={"font_size_large"}
          text={props.type}
          textColor={"text_color_primary"}
        />
      </div> */}
      <div className="Campaign-list-data">
        <CustomText
          p
          fontSize={"font_size_medium"}
          text={"Views"}
          textColor={"text_light_weight_color"}
        />
        <CustomText
          p
          fontSize={"font_size_large"}
          text={props.View}
          textColor={"text_color_primary"}
        />
      </div>
      <div className="Campaign-list-data">
        <CustomText
          p
          fontSize={"font_size_medium"}
          text={"Proposals"}
          textColor={"text_light_weight_color"}
        />
        <CustomText
          p
          fontSize={"font_size_large"}
          text={props.Bids}
          textColor={"text_color_primary"}
        />
      </div>
      <div className="Campaign-list-data">
        <CustomText
          p
          fontSize={"font_size_medium"}
          text={"Contracts"}
          textColor={"text_light_weight_color"}
        />
        <CustomText
          p
          fontSize={"font_size_large"}
          text={props.Contract}
          textColor={"text_color_primary"}
        />
      </div>
      <div className="Campaign-list-data">
        <CustomText
          p
          fontSize={"font_size_medium"}
          text={"Status"}
          textColor={"text_light_weight_color"}
        />
        <CustomText
          p
          fontSize={"font_size_large"}
          text={props.Status}
          // textColor={"text_color_primary"}
        />
      </div>
      <div className="Campaign-list-data">
        <CustomText
          p
          fontSize={"font_size_medium"}
          text={"Expire on"}
          textColor={"text_light_weight_color"}
        />
        <CustomText
          p
          fontSize={"font_size_large"}
          text={props.Posted}
          textColor={"text_color_primary"}
        />
      </div>
    </div>
  );
};

export const AssignmentList = function (props) {
  return (
    <div
      className={`Campaign-list ${props.className}`}
      key={props.key}
      onClick={props.onClick}
    >
      <div className="Campaign-list-data-profile">
        <div>
          <Image source={props.source} className="campaign-list-profile" />
        </div>
        <div className="campaign-list-data m-r-16">
          <CustomText
            p
            fontSize={"font_size_medium"}
            text={props.influencerName}
            textColor={"text_color_primary"}
            noOfLine={"twoLines"}
          />
        </div>
      </div>
      <div className="Campaign-list-data">
        <CustomText
          p
          fontSize={"font_size_medium"}
          text={"Reward"}
          textColor={"text_light_weight_color"}
        />
        <CustomText
          p
          fontSize={"font_size_large"}
          text={props.rewardText}
          textColor={"text_color_primary"}
        />
      </div>
      <div style={{ minWidth: "350px" }} className="Campaign-list-data">
        <CustomText
          p
          fontSize={"font_size_medium"}
          text={"Deliverables"}
          textColor={"text_light_weight_color"}
        />
        <CustomText
          p
          fontSize={"font_size_large"}
          text={props.deliverablesText}
          textColor={"text_color_primary"}
        />
      </div>
      <div style={{ minWidth: 180 }} className="Campaign-list-data">
        <CustomText
          p
          fontSize={"font_size_medium"}
          text={"Status"}
          textColor={"text_light_weight_color"}
        />
        <CustomText
          p
          fontSize={"font_size_large"}
          text={props.status}
          textColor={"text_color_primary"}
        />
      </div>
    </div>
  );
};

export const TransactionsList = function (props) {
  return (
    <div className="transaction-list-main-container">
      <div className="">
        <CustomText
          p
          fontSize={"font_size_medium"}
          text={"Type"}
          textColor={"text_light_weight_color"}
        />
        <CustomText
          p
          fontSize={"font_size_large"}
          text={props.type}
          textColor={"text_color_primary"}
        />
      </div>
      <div className="">
        <CustomText
          p
          fontSize={"font_size_medium"}
          text={"Amount"}
          textColor={"text_light_weight_color"}
        />
        <CustomText
          p
          fontSize={"font_size_large"}
          text={props.amount}
          textColor={"text_color_primary"}
        />
      </div>
      <div className="">
        <CustomText
          p
          fontSize={"font_size_medium"}
          text={"Order ID"}
          textColor={"text_light_weight_color"}
        />
        <CustomText
          p
          fontSize={"font_size_large"}
          text={props.orderId}
          textColor={"text_color_primary"}
        />
      </div>
      {/* <div className="">
        <CustomText
          p
          fontSize={"font_size_medium"}
          text={"Status"}
          textColor={"text_light_weight_color"}
        />
        <CustomText
          p
          fontSize={"font_size_large"}
          text={props.status}
          // textColor={props.statusColor}
        />
      </div> */}
      <div className="">
        <CustomText
          p
          fontSize={"font_size_medium"}
          text={"Time"}
          textColor={"text_light_weight_color"}
        />
        <CustomText
          p
          fontSize={"font_size_large"}
          text={props.time}
          textColor={"text_color_primary"}
        />
      </div>
    </div>
  );
};

export const UnderLinedLinkCta = function (props) {
  return (
    <button style={Styles.underlinedLinkCtaContainer} onClick={props.onClick}>
      <div>
        <CustomText
          h2
          fontSize={props.fontSize}
          text={props.text}
          textColor={props.textColor}
          fontWeight={"Poppins_regular"}
        />
      </div>
    </button>
  );
};

export const CustomCheckBox = function (props) {
  return (
    <input
      style={Styles.CustomCheckBox}
      type={props.type}
      id={props.id}
      name={props.name}
      value={props.value}
      checked={props.checked}
      indeterminate={props.indeterminate}
      onChange={props.onChange}
      disabled={props.disabled}
      isInvalid={props.inValid}
      appearance={props.appearance}
    />
  );
};

export const CustomDropdown = function (props) {
  return (
    <select style={Styles.customDropdown} name={props.name} id={props.brand}>
      {props.children}
    </select>
  );
};

export const BorderedDropdown = function (props) {
  return (
    <select
      onBlur={props.onBlur}
      onChange={props.onChange}
      onSelect={props.onSelect}
      placeholder={props.placeholder}
      style={
        props.invert ? Styles.invertBorderDropDown : Styles.borderedDropdown
      }
      name={props.name}
      id={props.id}
    >
      {props.children}
    </select>
  );
};

export const CustomDropdownOptions = function (props) {
  return (
    <option style={Styles.dropDownOption} value={props.value}>
      {props.title}
    </option>
  );
};

export const CustomBox = function (props) {
  return (
    <div
      style={{
        width: props.width,
        height: props.height,
        background: "#FFFFFF 0% 0% no-repeat padding-box",
        boxShadow: "0px 1px 2px #00000029",
        borderRadius: props.borderRadious,
        opacity: 1,
        padding: props.padding,
        display: props.display,
        flexDirection: props.flexDirection,
        justifyContent: props.justifyContent,
        alignItems: props.alignItems,
        paddingTop: props.paddingTop,
        paddingRight: props.paddingRight,
        paddingBottom: props.paddingBottom,
        paddingLeft: props.paddingLeft,
      }}
    >
      {props.children}
    </div>
  );
};

export const InviteTeammate = function (props) {
  return (
    <div className="popup-box">
      <div className="box">
        <span className="close-icon" onClick={props.handleClose}>
          x
        </span>
        {props.content}
      </div>
    </div>
  );
};

export const SearchBar = function (props) {
  return (
    <div>
      <input type="text" style={props.style} maxLength={props.maxLength} />
    </div>
  );
};

export const ViewCards = function (props) {
  return (
    <>
      <div style={{ flexDirection: "column" }}>
        <div>
          <CustomText
            p
            text={props.title}
            textAlign={"text_align_left"}
            fontSize={"font_size_xl"}
            textColor={"text_color_primary"}
          />
        </div>
        <div style={Styles.view_cards_main}>{props.children}</div>
      </div>
    </>
  );
};

export const InfluencerDataCard = function (props) {
  return (
    <div className="influencer-data-card">
      <div>
        <div>
          <CustomText />
        </div>
        <div>
          <div>
            <Image source={props.source} height={40} width={40} />
          </div>
        </div>
      </div>
    </div>
  );
};

const categoryCard = ({ children }) => {
  const cardStyle = {
    borderRadius: "20px",
    border: "1px solid #090A14",
    padding: "2px 8px",
    margin: "10px",
  };

  return <div className="categoryCard">{children}</div>;
};

export const AnalyticsCard = function (props) {
  return (
    <div className="analytics-main-container">
      <div className="analytics-influencer-data">
        <CustomText h5 text={props.title} />

        <div style={{ gap: 3, }} className="flex-row">
          <CustomText
            h2
            text={props.value}
            textAlign={"text_align_left"}
            textColor={"text_color_primary"}
            className="typographyH7"
          />
          <CustomText
            p
            text={props.secondValue}
            className="typography14"
            textAlign={"text_align_left"}
            textColor={"text_color_secondary"}
          />
        </div>
      </div>
      <div className="analytics-icon">
        <Icon iconName={props.iconName} />
      </div>
    </div>
  );
};

// export const CampaignListAllData = function (props) {
//   return (
//     <div className="Campaign-list" key={props.key} onClick={props.onClick}>
//       <div className="Campaign-list-data-profile">
//         <div className="campaign-list-data m-r-16">
//           <CustomText
//             p
//             fontSize={"font_size_medium"}
//             text={props.series}
//             textColor={"text_color_primary"}
//             noOfLine={"twoLines"}
//           />
//         </div>
//         <div
//           style={{
//             borderRadious: "40px",
//           }}
//         >
//           <Image source={props.source} height={40} width={40} />
//         </div>
//         <div className="campaign-list-data m-r-16">
//           <CustomText
//             p
//             fontSize={"font_size_medium"}
//             text={props.title}
//             textColor={"text_color_primary"}
//             noOfLine={"twoLines"}
//           />
//         </div>
//       </div>
//       <div className="Campaign-list-data">
//         <CustomText
//           p
//           fontSize={"font_size_large"}
//           text={props.type}
//           textColor={"text_color_primary"}
//         />
//       </div>
//       <div className="Campaign-list-data">
//         <CustomText
//           p
//           fontSize={"font_size_large"}
//           text={props.View}
//           textColor={"text_color_primary"}
//         />
//       </div>
//       <div className="Campaign-list-data">
//         <CustomText
//           p
//           fontSize={"font_size_large"}
//           text={props.Bids}
//           textColor={"text_color_primary"}
//         />
//       </div>
//       <div className="Campaign-list-data">
//         <CustomText
//           p
//           fontSize={"font_size_large"}
//           text={props.Contract}
//           textColor={"text_color_primary"}
//         />
//       </div>
//       <div className="Campaign-list-data">
//         <CustomText
//           p
//           fontSize={"font_size_large"}
//           text={props.Status}
//           textColor={"text_color_primary"}
//         />
//       </div>
//       <div className="Campaign-list-data">
//         <CustomText
//           p
//           fontSize={"font_size_large"}
//           text={props.Posted}
//           textColor={"text_color_primary"}
//         />
//       </div>
//     </div>
//   );
// };

export const Sidebar = ({
  isOpen,
  onClose,
  Header,
  Footer,
  children,
  headerAlignment = "left",
  headerPaddingLeft,
  headerPaddingRight,
  sidebarWidth,
  overflow,
  headerClassName,
}) => {
  const [currentWidth, setCurrentWidth] = useState(sidebarWidth);
  const sidebarRef = useRef(null);

  const updateSidebarWidth = () => {
    const screenWidth = window.innerWidth;
    if (screenWidth <= 768 && screenWidth > 480) {
      setCurrentWidth("50%"); // Small screen width
    } else if (screenWidth <= 480) {
      setCurrentWidth("98%"); // Small screen width
    } else {
      setCurrentWidth(sidebarWidth); // Default width
    }
  };

  useEffect(() => {
    updateSidebarWidth(); // Set initial width
    window.addEventListener("resize", updateSidebarWidth); // Update on resize

    return () => {
      window.removeEventListener("resize", updateSidebarWidth); // Cleanup
    };
  }, [sidebarWidth]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  const handleWheel = (e) => {
    const el = sidebarRef.current;
    if (!el) return;

    const { scrollTop, scrollHeight, clientHeight } = el;
    const deltaY = e.deltaY;

    const isAtTop = scrollTop === 0;
    const isAtBottom = scrollTop + clientHeight >= scrollHeight;

    if ((isAtTop && deltaY < 0) || (isAtBottom && deltaY > 0)) {
      e.preventDefault();
    }
  };

  const handleTouchMove = (e) => {
    handleWheel(e); // Optional for basic mobile support
  };

  const alignmentStyles = {
    left: { justifyContent: "flex-start" },
    center: { justifyContent: "center" },
    right: { justifyContent: "flex-end" },
  };

  return (
    <div className={`sidebar-container-component${isOpen ? " open" : ""}`}>
      <div className="sidebar-overlay-component" onClick={onClose}></div>
      <div
        ref={sidebarRef}
        onWheel={handleWheel}
        onTouchMove={handleTouchMove}
        className="sidebar-content-component"
        style={{
          width: currentWidth, // Dynamically calculated width
          overflow: overflow ? overflow : "auto",
        }}
      >
        {Header && (
          <div
            className={headerClassName ? headerClassName : "sidebar-header"}
            style={{
              ...alignmentStyles[headerAlignment],
              paddingLeft: headerPaddingLeft,
              paddingRight: headerPaddingRight,
            }}
          >
            <Header />
            <div
              className="close-btn"
              onClick={onClose}
              style={{ cursor: "pointer" }}
            >
              <Icon iconName="crossIcon" height={14} width={14} />
            </div>
          </div>
        )}
        <div className="sidebar-body">{children}</div>
        {Footer && <div className="sidebar-footer">{<Footer />}</div>}
      </div>
    </div>
  );
};
export const PriceModal = ({
  isOpen,
  onClose,
  header,
  subheading,
  textinput,
  confirmButtonText,
  cancelButtonText,
  onConfirm,
  onCancel,
  confirmButtonDisabled,
  isLoading = false, // Loader for confirmation button
}) => {
  if (!isOpen) return null;

  return (
    <div className="cancellation-modal-overlay">
      <div className="price-modal-content">
        {/* Close Button */}
        <div className="cancellation-modal-close" onClick={onClose}>
          <Icon iconName="crossIcon" />
        </div>

        {/* Header Section */}
        <div className="price-modal-header">
          <h2>{header}</h2>
        </div>

        {/* Subheading Section */}
        <div className="price-modal-body">
          <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
            <p>{subheading}</p>
            <p>{textinput}</p>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="price-modal-footer">
          <button className="price-modal-cancel" onClick={onCancel}>
            {cancelButtonText}
          </button>
          <button
            className={`price-modal-confirm ${
              confirmButtonDisabled ? "disabled-confirm-button" : ""
            }`}
            onClick={onConfirm}
            disabled={confirmButtonDisabled}
          >
            {isLoading ? (
              <span className="cancellation-modal-loader"></span>
            ) : (
              confirmButtonText
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

// Follower tier configurations
const FOLLOWER_TIERS = {
  nano: { min: 1000, max: 10000, label: "1K-10K" },
  micro: { min: 10000, max: 50000, label: "10K-50K" },
  mid: { min: 50000, max: 250000, label: "50K-250K" },
  macro: { min: 250000, max: 1000000, label: "250K-1M" },
  top: { min: 1000000, max: 10000000, label: "1M+" },
};

const RANGE_LIMITS = {
  min: 1000,
  max: 10000000,
  step: 1000,
};

// Non-uniform slider points so lower follower ranges are easier to select
// while still covering up to 10M followers.
const SLIDER_POINTS = [
  1000,
  2000,
  3000,
  4000,
  5000,
  6000,
  7000,
  8000,
  9000,
  10000,
  20000,
  30000,
  40000,
  50000,
  100000,
  250000,
  500000,
  1000000,
  2000000,
  5000000,
  10000000,
];

// Map option values to tier keys for easier lookup
const VALUE_TO_TIER = {
  '1000': 'nano',
  '10000': 'micro',
  '50000': 'mid',
  '250000': 'macro',
  '1000000': 'top'
};

// Format number with K/M suffix
const formatFollowerCount = (num) => {
  if (num >= 1000000) return `${(num / 1000000).toFixed(1)}M`;
  if (num >= 1000) return `${(num / 1000).toFixed(0)}K`;
  return num.toString();
};

// Followers Custom Dropdown Component
const FollowersCustomDropdown = ({
  rangeValues: rangeValuesProp,
  setRangeValues: setRangeValuesProp,
  onChange,
  value,
  options,
  remove,
  setIsDropdownOpen,
  setSearchTerm,
  onToggle,
  getInfluencerDiscoveryList
}) => {
  // Local state for range values to prevent parent resets
  const [rangeValues, setRangeValues] = useState({
    min: typeof rangeValuesProp?.min === "number" ? rangeValuesProp.min : 1000,
    max: typeof rangeValuesProp?.max === "number" ? rangeValuesProp.max : 10000000
  });

  // Local string state so the inputs are freely editable (including clearing)
  const [minInput, setMinInput] = useState(
    typeof rangeValues.min === "number" ? String(rangeValues.min) : ""
  );
  const [maxInput, setMaxInput] = useState(
    typeof rangeValues.max === "number" ? String(rangeValues.max) : ""
  );

  const [selectedTierValue, setSelectedTierValue] = useState(
    value && !Array.isArray(value) && value.type === "tier" ? value.value : null
  );

  // Keep text inputs in sync whenever numeric range changes (slider, radio, or parent)
  useEffect(() => {
    setMinInput(
      typeof rangeValues.min === "number" && !isNaN(rangeValues.min)
        ? String(rangeValues.min)
        : ""
    );
    setMaxInput(
      typeof rangeValues.max === "number" && !isNaN(rangeValues.max)
        ? String(rangeValues.max)
        : ""
    );
  }, [rangeValues.min, rangeValues.max]);

  // Keep local selected tier in sync with parent value shape
  useEffect(() => {
    if (!value) {
      setSelectedTierValue(null);
      return;
    }

    if (Array.isArray(value)) {
      const tierItem = value.find((v) => v && v.type === "tier");
      if (tierItem) {
        setSelectedTierValue(tierItem.value);
        // Update range values from tier selection
        if (tierItem.min !== undefined && tierItem.max !== undefined) {
          setRangeValues({ min: Number(tierItem.min), max: Number(tierItem.max) });
        }
      } else {
        setSelectedTierValue(null);
      }
    } else if (value.type === "tier") {
      setSelectedTierValue(value.value);
      // Update range values from tier selection
      if (value.min !== undefined && value.max !== undefined) {
        setRangeValues({ min: Number(value.min), max: Number(value.max) });
      }
    } else if (value.type === "range") {
      // Only update if it's explicitly marked as a range type
      if (value.min !== undefined && value.max !== undefined) {
        setRangeValues({ min: Number(value.min), max: Number(value.max) });
      }
      setSelectedTierValue(null);
    } else {
      // Ignore value objects without a type - don't reset
    }
  }, [value]);

  const sliderIndexFromValue = (val) => {
    if (val === undefined || val === null || isNaN(val)) return 0;
    let closestIndex = 0;
    let smallestDiff = Infinity;
    SLIDER_POINTS.forEach((point, index) => {
      const diff = Math.abs(point - val);
      if (diff < smallestDiff) {
        smallestDiff = diff;
        closestIndex = index;
      }
    });
    return closestIndex;
  };

  const sliderValueFromIndex = (index) => {
    const clampedIndex = Math.min(
      Math.max(index, 0),
      SLIDER_POINTS.length - 1
    );
    return SLIDER_POINTS[clampedIndex];
  };

  // Handle slider change (both thumbs) - updates during drag
  const handleSliderChange = (event, newValue) => {
    if (Array.isArray(newValue)) {
      const [newMinIndex, newMaxIndex] = newValue;
      const newMin = sliderValueFromIndex(newMinIndex);
      const newMax = sliderValueFromIndex(newMaxIndex);
      setRangeValues({ min: Number(newMin), max: Number(newMax) });
      // Clear tier selection when manually adjusting slider
      setSelectedTierValue(null);
    }
  };

  // Handle slider change committed (when user releases) - updates parent
  const handleSliderChangeCommitted = (event, newValue) => {
    if (Array.isArray(newValue)) {
      const [newMinIndex, newMaxIndex] = newValue;
      const newMin = sliderValueFromIndex(newMinIndex);
      const newMax = sliderValueFromIndex(newMaxIndex);
      // Update parent's state as well
      if (setRangeValuesProp) {
        setRangeValuesProp({ min: Number(newMin), max: Number(newMax) });
      }
      onChange({ min: Number(newMin), max: Number(newMax), type: "range" });
    }
  };

  // Handle minimum input change
  const handleMinInputChange = (e) => {
    const inputValue = e.target.value;
    setMinInput(inputValue);
    const val = parseInt(inputValue, 10);

    // Clear tier selection when manually typing
    setSelectedTierValue(null);

    // If empty or invalid, just update the text input and wait for blur
    if (inputValue === '' || isNaN(val)) {
      return;
    }

    // Update with numeric value for slider compatibility
    setRangeValues({ min: Number(val), max: Number(rangeValues.max) });

    // Validate and update parent if valid
    const maxVal = Number(rangeValues.max);
    if (val >= RANGE_LIMITS.min && val < maxVal) {
      onChange({ min: Number(val), max: Number(maxVal), type: "range" });
    }
  };

  // Handle maximum input change
  const handleMaxInputChange = (e) => {
    const inputValue = e.target.value;
    setMaxInput(inputValue);
    const val = parseInt(inputValue, 10);

    // Clear tier selection when manually typing
    setSelectedTierValue(null);

    // If empty or invalid, just update the text input and wait for blur
    if (inputValue === '' || isNaN(val)) {
      return;
    }

    // Update with numeric value for slider compatibility
    setRangeValues({ min: Number(rangeValues.min), max: Number(val) });

    // Validate and update parent if valid
    const minVal = Number(rangeValues.min);
    if (val <= RANGE_LIMITS.max && val > minVal) {
      onChange({ min: Number(minVal), max: Number(val), type: "range" });
    }
  };

  // Handle input blur (validate when user leaves field)
  const handleMinInputBlur = () => {
    let val = parseInt(minInput, 10);

    // If invalid, empty, or out of bounds, set to minimum limit
    if (isNaN(val) || val < RANGE_LIMITS.min) {
      val = RANGE_LIMITS.min;
    }

    // Ensure min doesn't exceed or equal max
    const maxVal = Number(rangeValues.max);
    if (isNaN(maxVal)) {
      const newMin = Number(val);
      const newMax = Number(RANGE_LIMITS.max);
      setRangeValues({ min: newMin, max: newMax });
      setMinInput(String(newMin));
      setMaxInput(String(newMax));
      onChange({ min: newMin, max: newMax, type: "range" });
      return;
    }

    if (val >= maxVal) {
      val = Math.max(RANGE_LIMITS.min, maxVal - RANGE_LIMITS.step);
    }

    const newMin = Number(val);
    const newMax = Number(maxVal);
    setRangeValues({ min: newMin, max: newMax });
    setMinInput(String(newMin));
    setMaxInput(String(newMax));
    // Clear tier selection when manually adjusting values
    setSelectedTierValue(null);
    // Update parent's state as well
    if (setRangeValuesProp) {
      setRangeValuesProp({ min: newMin, max: newMax });
    }
    onChange({ min: newMin, max: newMax, type: "range" });
  };

  const handleMaxInputBlur = () => {
    let val = parseInt(maxInput, 10);

    // If invalid, empty, or out of bounds, set to maximum limit
    if (isNaN(val) || val > RANGE_LIMITS.max) {
      val = RANGE_LIMITS.max;
    }

    // Ensure max doesn't go below or equal min
    const minVal = Number(rangeValues.min);
    if (isNaN(minVal)) {
      const newMin = Number(RANGE_LIMITS.min);
      const newMax = Number(val);
      setRangeValues({ min: newMin, max: newMax });
      setMinInput(String(newMin));
      setMaxInput(String(newMax));
      onChange({ min: newMin, max: newMax, type: "range" });
      return;
    }

    if (val <= minVal) {
      val = Math.min(RANGE_LIMITS.max, minVal + RANGE_LIMITS.step);
    }

    const newMin = Number(minVal);
    const newMax = Number(val);
    setRangeValues({ min: newMin, max: newMax });
    setMinInput(String(newMin));
    setMaxInput(String(newMax));
    // Clear tier selection when manually adjusting values
    setSelectedTierValue(null);
    // Update parent's state as well
    if (setRangeValuesProp) {
      setRangeValuesProp({ min: newMin, max: newMax });
    }
    onChange({ min: newMin, max: newMax, type: "range" });
  };

  // Handle radio button selection
  const handleTierSelection = (option) => {
    const tierKey = VALUE_TO_TIER[option.value];
    if (!tierKey) return;

    const tier = FOLLOWER_TIERS[tierKey];
    const newMin = Number(tier.min);
    const newMax = Number(tier.max);

    // Update local state immediately for responsive UI
    setRangeValues({ min: newMin, max: newMax });
    setMinInput(String(newMin));
    setMaxInput(String(newMax));
    setSelectedTierValue(option.value);

    // Update parent's state as well
    if (setRangeValuesProp) {
      setRangeValuesProp({ min: newMin, max: newMax });
    }

    // Notify parent with complete value object
    const valueToSend = {
      value: option.value,
      type: "tier",
      label: option.label,
      min: newMin,
      max: newMax
    };
    onChange(valueToSend);
  };

  // Check if a tier is selected - must match both min and max
  const isTierSelected = (option) => {
    const tierKey = VALUE_TO_TIER[option.value];
    if (!tierKey) return false;

    const tier = FOLLOWER_TIERS[tierKey];
    // Radio should only be selected if BOTH min and max match the tier exactly
    return Number(rangeValues.min) === Number(tier.min) &&
           Number(rangeValues.max) === Number(tier.max);
  };

  // Handle clear button
  const handleFollowersClear = () => {
    const resetRange = { min: RANGE_LIMITS.min, max: RANGE_LIMITS.max };
    setRangeValues(resetRange);
    setMinInput(String(RANGE_LIMITS.min));
    setMaxInput(String(RANGE_LIMITS.max));
    setSelectedTierValue(null);
    onChange(null);
    if (remove) remove();
    if (setIsDropdownOpen) setIsDropdownOpen(false);
    if (setSearchTerm) setSearchTerm("");
    if (onToggle) onToggle(false);
    if (getInfluencerDiscoveryList) getInfluencerDiscoveryList();
  };

  // Handle apply button
  const handleFollowersApply = () => {
    const currentValue = value || { min: rangeValues.min, max: rangeValues.max, type: "range" };
    // Ensure parent has the latest range before applying
    if (!value || typeof value !== "object") {
      onChange({ min: rangeValues.min, max: rangeValues.max, type: "range" });
    } else if (value.type !== "range" && value.type !== "tier") {
      onChange({ ...currentValue, min: rangeValues.min, max: rangeValues.max });
    }

    if (getInfluencerDiscoveryList) getInfluencerDiscoveryList();
    if (setIsDropdownOpen) setIsDropdownOpen(false);
    if (setSearchTerm) setSearchTerm("");
    if (onToggle) onToggle(false);
  };

  return (
    <>
      <div className="followers-dropdown-container">
        {/* Slider Section */}
        <div className="followers-section">
          <h3 className="followers-section-title">Select Followers</h3>

          <div className="followers-slider-wrapper">
            <Slider
              getAriaLabel={() => 'Followers range'}
              value={[
                sliderIndexFromValue(
                  typeof rangeValues.min === 'number' && !isNaN(rangeValues.min)
                    ? rangeValues.min
                    : RANGE_LIMITS.min
                ),
                sliderIndexFromValue(
                  typeof rangeValues.max === 'number' && !isNaN(rangeValues.max)
                    ? rangeValues.max
                    : RANGE_LIMITS.max
                ),
              ]}
              onChange={handleSliderChange}
              onChangeCommitted={handleSliderChangeCommitted}
              valueLabelDisplay="auto"
              getAriaValueText={(index) =>
                formatFollowerCount(sliderValueFromIndex(index))
              }
              valueLabelFormat={(index) =>
                formatFollowerCount(sliderValueFromIndex(index))
              }
              min={0}
              max={SLIDER_POINTS.length - 1}
              step={1}
              disableSwap={false}
              sx={{
                color: "#1977f2",
                height: 6,
                "& .MuiSlider-thumb": {
                  width: 22,
                  height: 22,
                  backgroundColor: "#fff",
                  border: "3px solid #1977f2",
                  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.15)",
                  "&:hover, &.Mui-focusVisible": {
                    boxShadow: "0 0 0 8px rgba(25, 119, 242, 0.16)",
                  },
                  "&.Mui-active": {
                    boxShadow: "0 0 0 12px rgba(25, 119, 242, 0.16)",
                  },
                },
                "& .MuiSlider-track": {
                  backgroundColor: "#1977f2",
                  border: "none",
                  height: 6,
                },
                "& .MuiSlider-rail": {
                  backgroundColor: "#e0e0e0",
                  height: 6,
                },
                "& .MuiSlider-valueLabel": {
                  backgroundColor: "#1977f2",
                  borderRadius: "4px",
                  padding: "4px 8px",
                },
              }}
            />
          </div>

          <div className="followers-inputs-row">
            <div className="followers-input-group">
              <label className="followers-input-label">Minimum Followers</label>
              <input
                type="number"
                className="followers-input"
                value={minInput}
                onChange={handleMinInputChange}
                onBlur={handleMinInputBlur}
                min={RANGE_LIMITS.min}
                max={rangeValues.max - RANGE_LIMITS.step}
                placeholder="Min followers"
              />
            </div>

            <div className="followers-input-group">
              <label className="followers-input-label">Maximum Followers</label>
              <input
                type="number"
                className="followers-input"
                value={maxInput}
                onChange={handleMaxInputChange}
                onBlur={handleMaxInputBlur}
                min={rangeValues.min + RANGE_LIMITS.step}
                max={RANGE_LIMITS.max}
                placeholder="Max followers"
              />
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="followers-separator" />

        {/* Radio Buttons Section */}
        <div className="followers-section">
          <h3 className="followers-section-title">Select by Influencer Size</h3>

          <div className="followers-tiers-list">
            {options.map((option) => {
              const isSelected = isTierSelected(option);
              const tierKey = VALUE_TO_TIER[option.value];
              const tierRange = tierKey ? `${FOLLOWER_TIERS[tierKey].label} Followers` : "";

              return (
                <label
                  key={option.value}
                  className={`followers-tier-item ${isSelected ? "selected" : ""}`}
                >
                  <div className="followers-tier-left">
                    <input
                      type="radio"
                      name="influencer_tier"
                      checked={isSelected}
                      onChange={() => handleTierSelection(option)}
                      className="followers-tier-radio"
                    />
                    <span className="followers-tier-name">
                      {option.label.split("  ")[0]}
                    </span>
                  </div>
                  <span className="followers-tier-range">{tierRange}</span>
                </label>
              );
            })}
          </div>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="filter-actions">
        <button
          className="clear-filter-btn"
          onClick={handleFollowersClear}
          type="button"
        >
          Clear Filter
        </button>
        <button
          className="apply-filter-btn"
          onClick={handleFollowersApply}
          type="button"
        >
          Apply
        </button>
      </div>

      <style>{`
        .followers-dropdown-container {
          padding: 16px;
          max-height: 400px;
          overflow-y: auto;
        }

        .followers-section {
          margin-bottom: 16px;
        }

        .followers-section-title {
          font-size: 15px;
          font-weight: 600;
          color: #1a1a1a;
          margin: 0 0 0px 0;
        }

        .followers-slider-wrapper {
          padding: 8px;
        }

        .followers-inputs-row {
          display: flex;
          gap: 12px;
        }

        .followers-input-group {
          width: 135px;
          display: flex;
          flex-direction: column;
          gap: 6px;
        }

        .followers-input-label {
          font-size: 12px;
          font-weight: 500;
          color: #666;
        }

        .followers-input {
          padding: 10px 12px;
          border: 1.5px solid #d8d8d8;
          border-radius: 6px;
          font-size: 14px;
          color: #1a1a1a;
          transition: all 0.2s;
          outline: none;
        }

        .followers-input:focus {
          border-color: #1977f2;
          box-shadow: 0 0 0 3px rgba(25, 119, 242, 0.1);
        }

        .followers-input:hover {
          border-color: #b0b0b0;
        }

        .followers-divider {
          font-size: 18px;
          color: #999;
          padding-bottom: 8px;
          font-weight: 300;
        }

        .followers-separator {
          height: 1px;
          background: #e8e8e8;
          margin: 16px 0;
        }

        .followers-tiers-list {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .followers-tier-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px 12px;
          border-radius: 6px;
          cursor: pointer;
          transition: all 0.2s;
          border: 1.5px solid transparent;
        }

        .followers-tier-item:hover {
          background-color: #f7f9fc;
        }

        .followers-tier-item.selected {
          background-color: #f0f7ff;
          border-color: #1977f2;
        }

        .followers-tier-left {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .followers-tier-radio {
          width: 18px;
          height: 18px;
          cursor: pointer;
          accent-color: #1977f2;
        }

        .followers-tier-name {
          font-size: 14px;
          color: #1a1a1a;
          font-weight: 500;
        }

        .followers-tier-item.selected .followers-tier-name {
          font-weight: 600;
          color: #1977f2;
        }

        .followers-tier-range {
          font-size: 13px;
          color: #666;
          font-weight: 400;
        }

        .followers-tier-item.selected .followers-tier-range {
          color: #1977f2;
          font-weight: 500;
        }

        /* Remove number input spinner */
        .followers-input::-webkit-inner-spin-button,
        .followers-input::-webkit-outer-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }

        .followers-input[type=number] {
          -moz-appearance: textfield;
        }
      `}</style>
    </>
  );
};

export const FilterDropdown = ({
  label,
  labelNode,
  value,
  onChange,
  remove,
  options = [],
  inputType = "checkbox", // "checkbox", "radio", "multiselect", "singleselect", "range"
  placeholder = "",
  isOpen = false,
  onToggle,
  rangeConfig = {},
  getInfluencerDiscoveryList,
  optionRenderer,
  searchEnabled,
  hideOptionInput = false,
  dropdownPosition = "left", // "left" or "right"
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(isOpen);
  const [rangeValues, setRangeValues] = useState(() => {
    if (value && value.min !== undefined && value.max !== undefined) {
        return { min: Number(value.min), max: Number(value.max) };
    }
    return {
        min: Number(rangeConfig.min || 1000),
        max: Number(rangeConfig.max || 100000),
    };
  });

  useEffect(() => {
     if (value && value.min !== undefined && value.max !== undefined) {
         setRangeValues({ min: Number(value.min), max: Number(value.max) });
     }
  }, [value]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredOptions, setFilteredOptions] = useState(options);
  const dropdownRef = useRef(null);
  const searchInputRef = useRef(null);
  const [initialValue, setInitialValue] = useState(value);

  // Robust: always determine selected categories from value
  const selectedCategoryValues = Array.isArray(value)
    ? value
        .filter((v) => v.type === "category" || v.isCategory === true)
        .map((v) => v.value)
    : [];

  // Helper: shallow compare arrays of objects by value/id
  const arraysEqual = (a, b) => {
    if (!Array.isArray(a) || !Array.isArray(b)) return false;
    if (a.length !== b.length) return false;
    return a.every((item, idx) => {
      if (item.value !== undefined && b[idx]?.value !== undefined) {
        return item.value === b[idx].value;
      }
      if (item.id !== undefined && b[idx]?.id !== undefined) {
        return item.id === b[idx].id;
      }
      return false;
    });
  };

  // Filter options based on search term
  useEffect(() => {
    if (!searchTerm.trim()) {
      setFilteredOptions(options);
    } else {
      const filtered = options.filter(
        (option) =>
          option.label?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          option.value
            ?.toString()
            .toLowerCase()
            .includes(searchTerm.toLowerCase())
      );
      setFilteredOptions(filtered);
    }
  }, [searchTerm, options]);

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
        setSearchTerm(""); // Clear search when closing
        if (onToggle) onToggle(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onToggle]);

  // Handle keydown for search functionality
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (!isDropdownOpen) return;

      // Do not hijack typing when focus is inside an input/textarea or contentEditable element
      const target = event.target;
      const tagName = target && target.tagName;
      if (
        tagName === "INPUT" ||
        tagName === "TEXTAREA" ||
        target.isContentEditable
      ) {
        return;
      }

      // Only handle alphanumeric keys, space, and backspace
      if (event.key.length === 1 || event.key === "Backspace") {
        event.preventDefault();

        if (event.key === "Backspace") {
          setSearchTerm((prev) => prev.slice(0, -1));
        } else if (event.key.length === 1) {
          setSearchTerm((prev) => prev + event.key);
        }

        // Focus the hidden input to maintain cursor
        if (searchInputRef.current) {
          searchInputRef.current.focus();
        }
      }
    };

    if (isDropdownOpen) {
      document.addEventListener("keydown", handleKeyDown);
      // Focus the hidden input when dropdown opens
      if (searchInputRef.current) {
        searchInputRef.current.focus();
      }
    }

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isDropdownOpen]);

  useEffect(() => {
    if (!isDropdownOpen) {
      if (
        inputType !== "followers_custom" &&
        getInfluencerDiscoveryList &&
        !arraysEqual(value, initialValue)
        // && inputType !== "singleselect"
      ) {
        getInfluencerDiscoveryList();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDropdownOpen]);

  if (label === "Gender") console.log("value in filter : ", value, options);

  const toggleDropdown = () => {
    if (isDropdownOpen) {
      setIsDropdownOpen(false);
      setSearchTerm(""); // Clear search when closing
      if (onToggle) onToggle(false);
    } else {
      setInitialValue(value);
      setIsDropdownOpen(true);
      setSearchTerm(""); // Clear search when opening
      if (onToggle) onToggle(true);
    }
  };

  const handleCheckboxChange = (optionValue, option, checked) => {
    if (inputType === "checkbox" || inputType === "multiselect") {
      let newValue = Array.isArray(value) ? [...value] : [];
      if (checked) {
        if (!isOptionSelected(option)) {
          newValue.push(option);
        }
      } else {
        newValue = newValue.filter(
          (v) =>
            !(
              (v?.value !== undefined &&
                option?.value !== undefined &&
                v.value === option.value) ||
              (v?.id !== undefined &&
                option?.id !== undefined &&
                v.id === option.id)
            )
        );
      }
      onChange(newValue);
    } else if (inputType === "radio" || inputType === "singleselect") {
      // Check if the clicked option is already selected
      const isCurrentlySelected = isOptionSelected(option);

      if (isCurrentlySelected) {
        // If already selected, just close the dropdown without changing the value
        setIsDropdownOpen(false);
        setSearchTerm(""); // Clear search when closing
        if (onToggle) onToggle(false);
      } else {
        // If not selected, select it and close dropdown
        onChange([option]);
        // getInfluencerDiscoveryList && getInfluencerDiscoveryList();
        setIsDropdownOpen(false);
        setSearchTerm(""); // Clear search when closing
        if (onToggle) onToggle(false);
      }
    }
  };

  const handleFollowersClear = () => {
    const resetRange = { min: RANGE_LIMITS.min, max: RANGE_LIMITS.max };
    setRangeValues(resetRange);
    onChange(null);
    remove && remove();
    setIsDropdownOpen(false);
    setSearchTerm("");
    if (onToggle) onToggle(false);
  };

  const handleFollowersApply = () => {
    const currentValue = value || { min: rangeValues.min, max: rangeValues.max, type: "range" };
    // Ensure parent has the latest range before applying
    if (!value || typeof value !== "object") {
      onChange({ min: rangeValues.min, max: rangeValues.max, type: "range" });
    } else if (value.type !== "range" && value.type !== "tier") {
      onChange({ ...currentValue, min: rangeValues.min, max: rangeValues.max });
    }

    if (getInfluencerDiscoveryList) getInfluencerDiscoveryList();
    setIsDropdownOpen(false);
    setSearchTerm("");
    if (onToggle) onToggle(false);
  };

  // Apply filter: call API and close dropdown
  const handleApplyFilter = () => {
    // if (getInfluencerDiscoveryList) getInfluencerDiscoveryList();
    setIsDropdownOpen(false);
    setSearchTerm(""); // Clear search when closing
    if (onToggle) onToggle(false);
  };

  // Clear filter: clear selection and close dropdown
  const handleClearFilter = () => {
    onChange([]);
    remove();
    setIsDropdownOpen(false);
    setSearchTerm(""); // Clear search when closing
    getInfluencerDiscoveryList();
    if (onToggle) onToggle(false);
  };

  const handleRangeChange = (type, newValue) => {
    const updatedRange = {
      ...rangeValues,
      [type]: parseInt(newValue),
    };

    // Ensure min doesn't exceed max and vice versa
    if (type === "min" && updatedRange.min > updatedRange.max) {
      updatedRange.max = updatedRange.min;
    }
    if (type === "max" && updatedRange.max < updatedRange.min) {
      updatedRange.min = updatedRange.max;
    }

    setRangeValues(updatedRange);
    onChange(updatedRange);
  };

  const getSelectedCount = () => {
    if (inputType === "range") return "";
    if (inputType === "multiselect" || inputType === "checkbox") {
      // Only count categories for the Category filter
      if (label === "Category") {
        if (!Array.isArray(value)) return "";
        const catCount = value.filter(
          (v) => v.type === "category" || v.isCategory === true
        ).length;
        return catCount > 0 ? ` (${catCount})` : "";
      }
      return Array.isArray(value) && value.length > 0
        ? ` (${value.length})`
        : "";
    }
    if (inputType === "singleselect" || inputType === "radio") {
      return Array.isArray(value) && value.length > 0 ? " (1)" : "";
    }
    return "";
  };

  const formatRangeValue = (val) => {
    if (val >= 1000000) return `${(val / 1000000).toFixed(1)}M`;
    if (val >= 1000) return `${(val / 1000).toFixed(0)}K`;
    return val.toString();
  };

  // Helper function to check if an option is selected
  const isOptionSelected = (option) => {
    if (!Array.isArray(value)) return false;

    return value.some((selectedItem) => {
      // Handle primitive values (strings, numbers) directly
      if (typeof selectedItem !== "object" || selectedItem === null) {
        return selectedItem === option.value || selectedItem === option.id;
      }

      // Handle object comparisons
      // Priority 1: Compare by value if both have non-null/undefined value
      if (
        selectedItem?.value !== undefined &&
        selectedItem.value !== null &&
        option?.value !== undefined &&
        option.value !== null
      ) {
        return selectedItem.value === option.value;
      }

      // Priority 2: Compare by id if both have non-null/undefined id
      if (
        selectedItem?.id !== undefined &&
        selectedItem.id !== null &&
        option?.id !== undefined &&
        option.id !== null
      ) {
        return selectedItem.id === option.id;
      }

      // Priority 3: Cross-comparison - selectedItem.value with option.id
      if (
        selectedItem?.value !== undefined &&
        selectedItem.value !== null &&
        option?.id !== undefined &&
        option.id !== null
      ) {
        return selectedItem.value === option.id;
      }

      // Priority 4: Cross-comparison - selectedItem.id with option.value
      if (
        selectedItem?.id !== undefined &&
        selectedItem.id !== null &&
        option?.value !== undefined &&
        option.value !== null
      ) {
        return selectedItem.id === option.value;
      }

      return false;
    });
  };

  // Set width based on labelNode
  const dropdownWidth = labelNode ? "80px" : undefined;

  return (
    <div className="filter-dropdown-container">
      <button
        className={`filter-dropdown-trigger ${
          isDropdownOpen ||
          (inputType === "singleselect"
            ? Array.isArray(value) && value.length > 0
            : getSelectedCount() != "")
            ? "active"
            : ""
        }`}
        onClick={toggleDropdown}
        type="button"
      >
        <span
          className={`filter-label ${
            isDropdownOpen ||
            (inputType === "singleselect"
              ? Array.isArray(value) && value.length > 0
              : getSelectedCount() != "")
              ? "active"
              : ""
          }`}
        >
          {labelNode
            ? labelNode
            : inputType === "singleselect" || inputType === "radio"
            ? Array.isArray(value) && value.length > 0
              ? value[0]?.label || label
              : label
            : label}
          {inputType !== "singleselect" && getSelectedCount()}
        </span>
        <div className={`filter-chevron ${isDropdownOpen ? "rotated" : ""}`}>
          <Icon iconName="filter_chevron" />
        </div>
      </button>

      {isDropdownOpen && (
        <div
          className={`${dropdownWidth ? "" : "filter-dropdown-content"}`}
          ref={dropdownRef}
          style={dropdownPosition === "left" ? { left: 0, right: 'auto' } : {}}
        >
          {/* Hidden search input for capturing keystrokes */}
          {}
          {searchEnabled && (
            <div style={{ position: "relative" }}>
              <input
                ref={searchInputRef}
                type="text"
                value={searchTerm}
                className="content-research-search-box-input"
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  position: "relative",
                  left: "15.5px",
                  right: "15px",
                  top: 15,
                  width: "calc(100% - 30px)",
                  padding: "8px 25px",
                  marginBottom: "10px",
                  // opacity: 0,
                  // pointerEvents: "none",
                }}
                // autoFocus
              />
              {/* Left icon - always shows aiSearch icon */}
              <span
                style={{
                  position: "absolute",
                  left: 21,
                  top: "73%",
                  transform: "translateY(-50%)",
                  display: "flex",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <Icon
                  iconName="smallSearchIcon"
                  style={{
                    fontSize: 16,
                    color: "#aaa",
                    pointerEvents: "none",
                  }}
                />
              </span>
              {searchTerm?.length > 0 && (
                <span
                  onClick={() => {
                    setSearchTerm("");
                    setFilteredOptions(options);
                    if (searchInputRef.current) {
                      searchInputRef.current.focus();
                    }
                  }}
                  style={{
                    cursor: "pointer",
                    position: "absolute",
                    right: 21,
                    top: "73%",
                    transform: "translateY(-50%)",
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  <Icon
                    iconName="crossIconSmall"
                    style={{
                      fontSize: 20,
                      color: "#aaa",
                      pointerEvents: "none",
                    }}
                  />
                </span>
              )}
            </div>
          )}

          {inputType === "range" ? (
            <div className="range-slider-container">
              <div className="range-header">
                <span className="range-label">{label}</span>
              </div>

              <div className="dual-range-slider">
                <div className="range-track">
                  <div
                    className="range-progress"
                    style={{
                      left: `${
                        ((rangeValues.min - rangeConfig.min) /
                          (rangeConfig.max - rangeConfig.min)) *
                        100
                      }%`,
                      width: `${
                        ((rangeValues.max - rangeValues.min) /
                          (rangeConfig.max - rangeConfig.min)) *
                        100
                      }%`,
                    }}
                  ></div>
                </div>

                <input
                  type="range"
                  className="range-input range-min"
                  min={rangeConfig.min || 1000}
                  max={rangeConfig.max || 100000}
                  step={rangeConfig.step || 1000}
                  value={rangeValues.min}
                  onChange={(e) => handleRangeChange("min", e.target.value)}
                />

                <input
                  type="range"
                  className="range-input range-max"
                  min={rangeConfig.min || 1000}
                  max={rangeConfig.max || 100000}
                  step={rangeConfig.step || 1000}
                  value={rangeValues.max}
                  onChange={(e) => handleRangeChange("max", e.target.value)}
                />
              </div>

              <div className="range-values">
                <span className="range-value-display">
                  {formatRangeValue(rangeValues.min)} -{" "}
                  {formatRangeValue(rangeValues.max)}
                </span>
              </div>
            </div>
          ) : inputType === "followers_custom" ? (
            <FollowersCustomDropdown
              rangeValues={rangeValues}
              setRangeValues={setRangeValues}
              onChange={onChange}
              value={value}
              options={options}
              remove={remove}
              setIsDropdownOpen={setIsDropdownOpen}
              setSearchTerm={setSearchTerm}
              onToggle={onToggle}
              getInfluencerDiscoveryList={getInfluencerDiscoveryList}
            />
          ) : (
            <>
              <div
                className={`options-container ${
                  inputType === "multiselect" || inputType === "checkbox"
                    ? "with-actions"
                    : ""
                } ${dropdownWidth ? " narrow-dropdown" : ""}`}
                // style={dropdownWidth ? { width: dropdownWidth } : {}}
              >
                {filteredOptions.length > 0 ? (
                  filteredOptions.map((option) => (
                    <label
                      key={option.value}
                      className="option-item"
                      style={
                        option.type === "subcategory" ||
                        option.isCategory === false
                          ? {
                              paddingLeft: 40,
                              display: "flex",
                              alignItems: "center",
                            }
                          : { display: "flex", alignItems: "center" }
                      }
                    >
                      <input
                        type={
                          inputType === "multiselect" ||
                          inputType === "checkbox"
                            ? "checkbox"
                            : "radio"
                        }
                        value={option.value}
                        checked={isOptionSelected(option)}
                        onChange={(e) =>
                          handleCheckboxChange(
                            option.value,
                            option,
                            e.target.checked
                          )
                        }
                        onClick={(e) => {
                          // For single select, handle click directly to close dropdown when clicking selected option
                          if (inputType === "radio" || inputType === "singleselect") {
                            e.preventDefault();
                            const isCurrentlySelected = isOptionSelected(option);

                            if (isCurrentlySelected) {
                              // If already selected, just close the dropdown
                              setIsDropdownOpen(false);
                              setSearchTerm("");
                              if (onToggle) onToggle(false);
                            } else {
                              // If not selected, select it and close dropdown
                              onChange([option]);
                              setIsDropdownOpen(false);
                              setSearchTerm("");
                              if (onToggle) onToggle(false);
                            }
                          }
                        }}
                        className="option-input"
                        name={
                          inputType === "radio" || inputType === "singleselect"
                            ? `${label}-radio`
                            : undefined
                        }
                        style={hideOptionInput ? { display: "none" } : undefined}
                        disabled={
                          option.type === "subcategory" &&
                          !selectedCategoryValues.includes(option.parent)
                        }
                      />
                      <span className="option-label">
                        {optionRenderer ? optionRenderer(option) : option.label}
                      </span>
                    </label>
                  ))
                ) : (
                  <div className="no-options">No options found</div>
                )}
              </div>

              {(inputType === "multiselect" || inputType === "checkbox") && (
                <div className="filter-actions">
                  <button
                    className="clear-filter-btn"
                    onClick={handleClearFilter}
                    type="button"
                  >
                    Clear Filter
                  </button>
                  <button
                    className="apply-filter-btn"
                    onClick={handleApplyFilter}
                    type="button"
                  >
                    Apply Filter
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export { default as CustomAgTable } from "./CustomAgTable";
